import * as React from 'react';
import { OnSale } from '../OnSale/OnSale';

export interface IProfileCreatedProps {
}

export function ProfileCreated(props: IProfileCreatedProps) {



    return (
        <div>
            <OnSale />
        </div>
    );
}
